export default "__VITE_ASSET__Cw2Ren9G__"